import {
  MapWithRelations,
  Operations,
} from "../../bookmydesk-api-sdk-typescript-axios";
import { kLocations } from "./locations";

export const kMaps: (MapWithRelations & Operations)[] = [
  {
    id: "00000011-0000-4000-a000-000000000005",
    name: "First floor",
    floor: "1",
    visible: true,
    image: "this-will-fail-when-used",
    width: 100,
    height: 100,
    limitMaximumBookedResources: -1,
    order: 0,
    locationId: kLocations[0].id,
    location: kLocations[0],
    _operations: {
      canDelete: false,
      cannotDeleteDescription:
        "Map has linked reservations, places, or walking directions",
    },
  },
  {
    id: "00000011-0000-4000-a000-000000000030",
    name: "Second floor",
    floor: "2",
    visible: true,
    image: "this-will-fail-when-used",
    width: 100,
    height: 100,
    limitMaximumBookedResources: -1,
    order: 0,
    locationId: kLocations[0].id,
    location: kLocations[0],
    _operations: {
      canDelete: true,
    },
  },
];
